import ApiService from "./axios";
import { HttpMethod } from "./baseHttpService";

export default class CompanyService {
  /**
   * @param {ApiService} apiService
   * @return {CompanyService}
   */
  constructor(apiService) {
    this.apiService = apiService;
  }

  async getTableCompanies(data) {
    const response = await this.apiService.request({
      method: HttpMethod.GET,
      params: data,
      url: `admin/company`,
    });
    return response;
  }

  async uploadCompanies(data) {
    const response = await this.apiService.request({
      method: HttpMethod.POST,
      payload: data,
      url: `admin/company`
    });
    return response;
  }
}
